/* eslint-disable @typescript-eslint/ban-types */
import React, { useEffect, useState } from 'react';
import { Box, Typography, IconButton, Paper } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { Handle, Position } from '@xyflow/react';
import { SidePopover } from '../../../globalUtils/globalExports';
import SetParameterSidePopover from './SetParameterSidePopover';
import './SetParameterNode.css'
import CloseIcon from '@mui/icons-material/Close';
import { ExecutionPlan, SetParameterAction, SetParameters } from './ExecutionPlan';
import { IconWithTooltip } from '../../../globalUtils/globalIcons';
interface CustomNodeProps {
  data: {
    actionButtonVisible: string,
    addNodeToCanvas,
    addIcon: boolean;
    executionPlan: ExecutionPlan;
    handleUpdateExecutionPlan: Function;
    ifOrElse: string;
    removeNode: Function;
    nodeId: string;
    typeOfNode: string;
    parentNodeId: string
  }
}

const SetParameterNode: React.FC<CustomNodeProps> = ({ data }: CustomNodeProps) => {

  const [isSetParameterPopoverOpen, setIsSetParameterPopoverOpen] = useState(false);
  const [setParameters, setSetParamaeters] = useState<SetParameters[] | null>(null);

  const handleEditClick = () => {
    setIsSetParameterPopoverOpen(true)
  };


  const handleCloseSetParameterPopover = (): void => {
    setIsSetParameterPopoverOpen(false)
  }

  useEffect(() => {
    const currentSetParameters = (data?.executionPlan?.actions?.find((executionPlanItem) => executionPlanItem.flowType === data?.ifOrElse && executionPlanItem?.parentNodeId === data?.parentNodeId)?.list?.find((executionPlanAction) => executionPlanAction.type === 'Set Parameter') as SetParameterAction)
    if (currentSetParameters) setSetParamaeters(currentSetParameters?.parameters)
  }, [data?.executionPlan])


  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>

        <Paper
          elevation={3}
          sx={{
            border: '1px solid #0080DC',
            borderLeft: '6px solid #0080DC',
            borderRadius: '8px',
            padding: '8px 16px',
            minWidth: '300px !important',
            backgroundColor: '#fff',
            position: 'relative',
            marginBottom: '16px',
            minHeight: '110px'
          }}
        >
          <IconButton
            size="small"
            onClick={() => {
              if (data?.removeNode) {
                data.removeNode(data?.nodeId);
              }
            }}
            sx={{ position: 'absolute', top: 0, right: 0 }}
          >
            <CloseIcon fontSize="small" sx={{ color: '#666' }} />
          </IconButton>

          <Handle type="target" className='transparent-handle' position={Position.Left} id='left' />
          <Handle type="source" position={Position.Bottom} className='transparent-handle' />
          <Handle type="source" position={Position.Left} className='transparent-handle' id='left' />

          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            marginBottom="8px"
          >
            {/* Title with Notification Icon */}
            <Box display="flex" alignItems="center">
              <IconWithTooltip iconClassName={'set-parameter-sidebar-1'} />
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: 600,
                  fontSize: '1rem',
                  marginBottom: '1px'
                }}
              >
                {'Set Parameter'}
              </Typography>
            </Box>
          </Box>

          {/* Category and Subcategory */}
          <Box
            sx={{
              backgroundColor: '#f0f4ff',
              padding: '8px',
              borderRadius: '10px',
              position: 'relative',
              display: 'flex'
            }}
          >
            {/* Set Parameter Items */}
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <span
                  style={{
                    width: '8px',
                    height: '8px',
                    backgroundColor: '#0080DC',
                    borderRadius: '50%',
                    display: 'inline-block',
                  }}
                />
                {!setParameters &&

                  <Typography
                    variant="body2"
                    sx={{ fontSize: '0.875rem', color: '#666', display: 'flex', alignItems: 'center', marginLeft: '5px' }}
                  >
                    Set()
                  </Typography>
                }
              </div>

              <Box display="flex" flexDirection="column" alignItems="left" justifyContent='space-between' sx={{ margin: 'auto 0 auto 5px' }}>
                {setParameters &&
                  setParameters.map((item, index) => {
                    return (
                      <Box
                        key={index}
                        sx={{
                          display: 'block',
                          width: '100%',
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            fontSize: '0.875rem',
                            color: '#333',
                            lineHeight: 1.5,
                          }}
                        >
                          {index === 0 ? <span className='rule__engine__define__execution__selected__parameters'>{'SET('}</span> : <span>{item.parameterOperator && item.parameterOperator.toLowerCase() + '('}</span>}
                          <span className='rule__engine__define__execution__selected__parameters'>{item.parameterName}</span>{' '}
                          <span >

                            {item.parameterConditionName?.toLocaleLowerCase()}{' '}
                          </span>
                          {item.parameterValue.length > 0 && (
                            <span className='rule__engine__define__execution__selected__parameters'>{item.parameterValue?.join(',')}</span>)}{' '}
                          {item.unit !== null && item.unit !== 'NA' && <span className='rule__engine__define__execution__selected__parameters'>{item?.unit}</span>}{')'}
                        </Typography>
                      </Box>
                    );
                  })}
              </Box>
              <IconButton
                size="small"
                onClick={handleEditClick}
                sx={{
                  ':hover': {
                    backgroundColor: 'transparent',
                  },
                }}
              >
                <EditIcon fontSize="small" sx={{ color: '#666' }} />
              </IconButton>
            </div>
          </Box>
        </Paper>
        {data.actionButtonVisible &&
          <Typography
            onClick={() => data.addNodeToCanvas()}
            variant="body2"
            sx={{
              color: '#B0B1B6',
              marginTop: '8px',
              marginLeft: '10px',
              cursor: 'pointer',
              fontSize: '0.875rem',
            }}
          >
            + Add Activity
          </Typography>
        }
      </div>
      {isSetParameterPopoverOpen && <SidePopover
        id='advance__rule__engine__execution__plan__set__parameter__side__popover'
        open={isSetParameterPopoverOpen}
        headerText={`Action Control - ${data.ifOrElse === 'If' ? 'Then' : 'Else'}`}
        headerSecondaryText={'Set Parameter'}
        horizontalLinePopover={true}
        containerClassName='advance__rule__engine__detail__popover'
        handleClose={() => { }}
        popperClassName='advance__rule__engine__set__parameter__popper'
        headerClassName={'advance__rule__engine__header__config'}
        subHeadingIconClassName={'set-parameter-sidebar'}
        isRuleEnginePopOver={true}
        ruleEngineSidePopoverOnclose={handleCloseSetParameterPopover}
        // eslint-disable-next-line react/no-children-prop
        children={
          <>
            {
              <SetParameterSidePopover
                setParameters={setParameters ?? null}
                executionPlan={data?.executionPlan}
                handleUpdateExecutionPlan={data?.handleUpdateExecutionPlan}
                handleClose={handleCloseSetParameterPopover}
                ifOrElse={data?.ifOrElse ?? ''}
                parentNodeId={data?.parentNodeId}
                nodeId={data?.nodeId}
              />
            }
          </>
        }
      />
      }

    </>

  );
};

export default SetParameterNode;

